import React, { useEffect, useState } from "react";
import Styles from "../styles/main.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import "../styles/dynamicTable.module.css";
import { Breadcrumbs, Grid, Link, TextField } from "@mui/material";
import axios from "axios";
import Loader from "../../../../Loader/Loader";
import { ls } from "../../../../variables";
import { encrypt } from "../../../../utils/cipher";
import { errorHandler } from "../../../../utils/errorHandling";
import { alert } from "../../../../utils/sweetAlert";
import { useStateValue } from "../../../../Hooks/stateProvider";

function getUID() {
  // Get the timestamp and convert
  // it into alphanumeric input
  return Date.now().toString(36);
}

const PMSTakeAction = () => {
  
  const pmsName = ls.get("pmsName");
  const [rows, setRows] = useState([]);
  const [{ fy_year, quarter, alertName }, dispatch] = useStateValue();
  const [storeInstanceId, setStoreInstanceId] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredRows, setFilteredRows] = useState(rows);
  const [columns, setColumns] = useState([])
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;
  let ticketUID = getUID();

  // let jsArray = [{ id: 1 }];

  useEffect(() => {
    if (fy_year != "" && quarter != "" && alertName != "")
      fetchData();
  }, []);

  const fetchData = async () => {
          const props = {
            alertName: alertName,
            instanceCount: data.instanceCount,
            ticketID: ticketUID,
          }
          
            navigate("/app/takeActionSettlement", { state: props });
            };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filteredData = rows.filter((row) =>
      Object.values(row).some((val) =>
        val?.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
    setFilteredRows(filteredData);
  };

  return (
    <>
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            {ls.get("userType") != "RTA" &&

              <Link
                underline="hover"
                color="inherit"
                onClick={() => navigate("/app/welcome")}
              >
                Welcome
              </Link>}
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate("/app/upload")}
            >
              Submission Page
            </Link>
            <Link
              underline="hover"
              color="inherit"
            >
              {alertName}
            </Link>
          </Breadcrumbs>
        </div>
        <Grid
          container
          sx={{
            width: "90vw",
            display: "flex",
            marginLeft: "5vw",
            marginBottom: "0.5%"
          }}
        >
          <Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "2rem" }}>
            <TextField
              style={{
                height: "2rem",
                width: "clamp(10rem,20vw,30rem)",
                borderColor: "#a4a4a4",
              }}
              id="outlined-basic"
              variant="outlined"
              placeholder="Search"
              className="textfield_input"
              value={searchQuery}
              onChange={handleSearch}
            />
            <button
              className={Styles.Preview}
              onClick={() => {
                const props = {
                  alertName: alertName,
                  instanceID: storeInstanceId,
                  ticketID: ticketUID,
                }
                if (props.instanceID.length > 0) {
                  navigate("/app/takeActionSettlement", { state: props });
                }
                else {
                  alert("Please select an alert to proceed to the next page", "", "warning")
                }

              }}
            >
              NEXT
            </button>
          </Grid>
        </Grid>
        <div
          style={{
            height: "80%",
            width: "90vw",
            marginLeft: "5vw",
            marginTop: "0%",
          }}
        >
          {rows.length == 0 ? (
            <Loader />
          ) : (
            <DataGrid
              rows={filteredRows}
              columns={columns}
              getRowHeight={() => "auto"}
              onRowSelectionModelChange={(selectedRowsID) => {

                const selectedIDs = new Set(selectedRowsID);
                const selectedRowData = filteredRows.filter(row => selectedIDs.has(row.id));

                let storeInstanceId = new Set();

                selectedRowData.forEach(val => {
                  storeInstanceId.add(val.case_id);
                });
                setStoreInstanceId(Array.from(storeInstanceId));
              }}
              sx={{
                width: "fit-content",
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  justifyContent: "center",
                  backgroundColor: "#154063",
                },
                "& .MuiDataGrid-withBorderColor": {
                  borderColor: "#154063",
                  borderRight: "none",
                },
                "& .MuiDataGrid-columnSeparator--sideRight": {
                  display: "none",
                },
                "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                  display: "none",
                },
                "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
                "& .MuiDataGrid-topContainer": { width: "fit-content" },
                "& .MuiDataGrid-cell": {
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "8px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "15px",
                },
              }}
              style={{
                color: "#154063",
                width: "100%",
                height: "100%",
                borderWidth: "2px",
                borderRadius: "10px",
              }}
              checkboxSelection
              hideFooterPagination
              rowsPerPageOptions={[2, 5, 10]}
              AutoGenerateColumns={false}
              // disableRowSelectionOnClick
              disableColumnMenu
              disableRowCount
              disableColumnSelector
              scrollbarSize={0}
            // autoWidth
            autoPageSize
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PMSTakeAction;
